import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "app/core/guards/auth.guard";
import { MainContainerComponent } from "app/features/main-container/main-container.component";
import { InsufficientPermissionsComponent } from "app/features/insufficient-permissions/insufficient-permissions.component";
import { AccountSelectionComponent } from "app/features/account-selection/account-selection.component";
import { AuthCallbackComponent } from "app/core/auth/callback/auth-callback.component";
import { RouteRestoreGuard } from "app/core/guards/route-restore.guard";

const routes: Routes = [
  {
    path: "",
    redirectTo: "nconnect-voice/shortcuts",
    pathMatch: "full", // make sure root redirects properly
  },
  {
    path: "insufficient-permissions",
    component: InsufficientPermissionsComponent,
  },
  {
    path: "auth/callback",
    component: AuthCallbackComponent,
  },
  {
    path: "account-selection",
    canActivate: [AuthGuard],
    component: AccountSelectionComponent,
  },
  {
    path: "",
    component: MainContainerComponent,
    canActivate: [RouteRestoreGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "nconnect-voice",
        loadChildren: () =>
          import("app/features/nconnect-voice/nconnect-voice.module").then(
            (m) => m.NconnectVoiceModule,
          ),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "nconnect-voice/shortcuts",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
